import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0A2F23] text-foreground-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-20">
          <div>
            <span className="font-heading text-2xl font-bold text-background-50 block mb-4">Itaobuy</span>
            <p className="text-sm text-foreground-200/80 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h5 className="section-label text-foreground-200 text-xs mb-5">{t('footer.newsletter')}</h5>
            <form className="relative" onSubmit={(e) => e.preventDefault()}>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute left-[-9999px] opacity-0 h-0 w-0 overflow-hidden pointer-events-none"
              />
              <input
                type="email"
                name="email"
                placeholder={t('footer.newsletter_placeholder')}
                className="w-full bg-transparent border-0 border-b border-foreground-200/30 pb-2 text-sm text-foreground-50 placeholder:text-foreground-200/50 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <button type="submit" className="absolute right-0 bottom-2 w-6 h-6 flex items-center justify-center cursor-pointer">
                <i className="ri-arrow-right-line text-foreground-50 text-sm"></i>
              </button>
            </form>
            <p className="text-xs text-foreground-200/50 mt-2">{t('footer.newsletter_hint')}</p>
          </div>

          <div>
            <h5 className="section-label text-foreground-200 text-xs mb-5">{t('footer.links')}</h5>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-200/80 hover:text-background-50 transition-colors cursor-pointer">{t('footer.link_home')}</Link>
              <Link to="/articoli/guida-itaobuy-spreadsheet" className="text-sm text-foreground-200/80 hover:text-background-50 transition-colors cursor-pointer">{t('footer.link_guide')}</Link>
              <Link to="/articoli/guida-itaobuy-spreadsheet" className="text-sm text-foreground-200/80 hover:text-background-50 transition-colors cursor-pointer">{t('footer.link_articles')}</Link>
            </div>
          </div>

          <div>
            <h5 className="section-label text-foreground-200 text-xs mb-5">{t('footer.social')}</h5>
            <div className="flex flex-col gap-2">
              <a href="#" className="text-sm text-foreground-200/80 hover:text-background-50 transition-colors cursor-pointer">Instagram</a>
              <a href="#" className="text-sm text-foreground-200/80 hover:text-background-50 transition-colors cursor-pointer">Pinterest</a>
              <a href="#" className="text-sm text-foreground-200/80 hover:text-background-50 transition-colors cursor-pointer">Telegram</a>
            </div>
          </div>
        </div>

        <div className="overflow-hidden">
          <div className="text-[#EAE6D9] font-heading font-black text-[clamp(4rem,12vw,10rem)] leading-none tracking-tighter whitespace-nowrap select-none opacity-80">
            ITAOBUY
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-200/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-200/50">{t('footer.copyright')}</p>
          <p className="text-xs text-foreground-200/50">itaobuyspread.beauty</p>
        </div>
      </div>
    </footer>
  );
}